var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['n-button','n-button-'+_vm.type,_vm.disabled?'btn-disabled':'',_vm.round?'n-button-radius':''],attrs:{"disabled":_vm.disabled},on:{"click":_vm.btnClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }